import React from "react";
const autobind = require("class-autobind").default;
import { FormGroup } from "../group/index";
import DayPicker from "react-day-picker";
import { Modal } from "../../layout/modal/index";
import { ModalContent } from "../../layout/modal/content";
import { Input } from "../input/index";
import { InputBox } from "../input.box/index";
import moment from "moment-timezone";
export class DateRangePicker extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            modal: "",
        };
    }
    onSelect(date) {
        const { onSelect } = this.props;
        const { modal } = this.state;
        if (modal === "")
            return;
        onSelect(modal, date.getTime());
        this.setState({ modal: "" });
    }
    render() {
        if (!this.state)
            return;
        const { start, end, formats, timezone } = this.props;
        const { modal } = this.state;
        const value = new Date(modal === "start" ? start : end);
        return (React.createElement("div", null,
            React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                    React.createElement(Input, { type: "text", value: start ? moment.tz(start, timezone).format(formats.date) : "", placeholder: "Click to select", className: "no-round width200", onClick: () => this.setState({ modal: "start" }), readOnly: true, required: true })),
                React.createElement(InputBox, { className: "no-round width48 text-center" },
                    React.createElement("p", { className: "font-semi-bold", style: { lineHeight: "36px" } }, "To")),
                React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                    React.createElement(Input, { type: "text", value: end ? moment.tz(end, timezone).format(formats.date) : "", placeholder: "Click to select", className: "no-round width200", onClick: () => this.setState({ modal: "end" }), readOnly: true, required: true }))),
            React.createElement(Modal, { active: !!modal, width: 265, closeButton: false, close: () => this.setState({ modal: "" }) }, (!!modal) && (React.createElement(ModalContent, { style: { minHeight: "283px" } },
                React.createElement(FormGroup, { contentClassName: "flex-center", className: "p-b-0" },
                    React.createElement(DayPicker, { selectedDays: value, onDayClick: this.onSelect })))))));
    }
}
//# sourceMappingURL=index.js.map